var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{style:({'overflow-x': 'auto', 'overflow-y': 'hidden'}),attrs:{"width":_vm.width,"options":_vm.options,"series":_vm.computedSeries,"height":"500px","type":"bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }